import { cva } from 'class-variance-authority';
export const getSkeletonClasses = cva('block shrink-0 overflow-hidden', {
    variants: {
        animation: { pulse: 'animate-pulse bg-subtle motion-reduce:animate-none', shimmer: '' },
        shape: { circle: 'rounded-full', rectangle: 'rounded-md', text: 'rounded-full' },
        size: { lg: '', md: '', sm: '' },
        width: { full: 'w-full', lg: 'w-3/4', md: 'w-1/2', sm: 'w-1/3' },
    },
    compoundVariants: [
        { shape: 'circle', size: 'sm', class: 'size-4' },
        { shape: 'circle', size: 'md', class: 'size-6' },
        { shape: 'circle', size: 'lg', class: 'size-10' },
        { shape: 'rectangle', size: 'sm', class: 'h-8' },
        { shape: 'rectangle', size: 'md', class: 'h-12' },
        { shape: 'rectangle', size: 'lg', class: 'h-24' },
        { shape: 'text', size: 'sm', class: 'h-2' },
        { shape: 'text', size: 'md', class: 'h-3' },
        { shape: 'text', size: 'lg', class: 'h-4' },
    ],
    defaultVariants: { animation: 'shimmer', shape: 'text', size: 'md' },
});
//# sourceMappingURL=classes.js.map